import { IntegrationInitializationModal } from '../IntegrationInitializationModal'
import { useModals } from 'almanac-ui/Modal'
import { Mailchimp } from 'blaze-ui/icons'
import { IntegrationInitializationDrawer } from '../IntegrationInitializationDrawer'
import { InitializationProps } from '../types'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { IntegrationNotice } from '../IntegrationNotice'
import Styles from '../IntegrationInitializationModal.module.scss'

export const MailchimpNotice = () => (
  <IntegrationNotice
    connectionGuideLink="https://help.blaze.ai/en/articles/11635461-connect-blaze-to-mailchimp"
    message={
      <div className={Styles.message}>
        To connect with Mailchimp, you'll need to authorize Blaze to access your Mailchimp account. This will allow you
        to sync your email campaigns.
        <div className={Styles.note}>For help with setup, please review our guide:</div>
      </div>
    }
  />
)

const MailchimpInitialization = ({ userIsAttemptingToPost = false, useDrawer = false }: InitializationProps) => {
  const { closeModal } = useModals()
  const { initiateOauth } = useInitiateOauth()

  const title = userIsAttemptingToPost ? 'Set up your Mailchimp integration' : 'Connect Mailchimp Account'

  const handleConfirm = () => {
    initiateOauth(ExternalIntegrationEnum.Mailchimp)
  }

  const sharedProps = {
    notice: <MailchimpNotice />,
    providerName: 'Mailchimp',
    onClose: closeModal,
    icon: <Mailchimp size={32} />,
    title,
    onConfirm: handleConfirm,
    primaryButtonText: 'Go to Mailchimp',
  }

  return useDrawer ? (
    <IntegrationInitializationDrawer {...sharedProps} />
  ) : (
    <IntegrationInitializationModal {...sharedProps} />
  )
}

export default MailchimpInitialization
